module.exports = __webpack_public_path__ + "static/3-9293af5384c2fa6f138b92ca899364ba.png";